// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiUrl: 'http://crmv3api.wtipl.in/',
//   logsApiUrl: 'http://crmv3api.wtipl.in/',
//   apiUrl: 'http://crmv3api.wtipl.in/',
// };

// export const environment = {
//   production: false,
//   apiUrl: 'https://localhost:44341/',
//   logsApiUrl: 'https://localhost:44341/',
//   apiUrl: 'https://localhost:44341/',
// };


export const environment = {
  production: false,
  //apiUrl: 'https://localhost:44349/',
  apiUrl: 'https://api.koaglobal.in/',
};


  // export const environment = {
  //   production: false,
  //   apiUrl: 'http://192.168.43.193:82/',
  //   logsApiUrl: 'http://192.168.43.193:82/',
  //   apiUrl: 'http://192.168.43.193:82/',
  //   };
  


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
 